import { ReactElement } from 'react'

import { Modal as AntModal } from 'antd'
import { ModalProps as AntModalProps, ModalFuncProps } from 'antd/es/modal'
import classNames from 'classnames'

import Icon from '../Icon/Icon'

import * as styles from './styles.scss'

export type ModalProps = Omit<AntModalProps, 'closeIcon'>

const ModalComponent = ({
    rootClassName,
    ...props
}: ModalProps): ReactElement => {
    return (
        <AntModal
            closeIcon={<Icon name="PLUS" rotate={45} size={20} />}
            rootClassName={classNames(styles.modal, rootClassName)}
            {...props}
        />
    )
}

ModalComponent.displayName = 'Modal'

// Re-export static methods from AntModal for confirm dialogs
export const Modal = Object.assign(ModalComponent, {
    confirm: AntModal.confirm,
    info: AntModal.info,
    success: AntModal.success,
    error: AntModal.error,
    warning: AntModal.warning,
    destroyAll: AntModal.destroyAll,
    useModal: AntModal.useModal,
})

export type { ModalFuncProps }
